import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OMIT_CONTENT_TYPE_HEADER } from '@garmin-avcloud/avcloud-web-utils';
import { switchMap } from 'rxjs';
import { DEFAULT_HTTP_HEADERS } from '../constants/default-http-headers.constants';
import { LdapTokenService } from '../services/ldap-token/ldap-token.service';

// list of URLs to exclude from interception
const ignoreList: string[] = ['https://static.garmincdn.com'];
const CLIENT_ID_HEADER = 'X-garmin-client-id';
const ACTOR_ID_HEADER = 'X-garmin-actor-id';

export const httpInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const ldapTokenService = inject(LdapTokenService);

  if (ignoreList.some((url) => req.url.startsWith(url))) {
    return next(req.clone());
  }

  let headers = req.headers
    .set(CLIENT_ID_HEADER, DEFAULT_HTTP_HEADERS[CLIENT_ID_HEADER])
    .set(ACTOR_ID_HEADER, DEFAULT_HTTP_HEADERS[ACTOR_ID_HEADER]);

  if (!(req.headers.getAll('Accept')?.includes(DEFAULT_HTTP_HEADERS['Accept']) ?? false)) {
    headers = headers.append('Accept', DEFAULT_HTTP_HEADERS['Accept']);
  }

  if (
    !req.context.get(OMIT_CONTENT_TYPE_HEADER) &&
    !(req.headers.getAll('Content-Type')?.includes(DEFAULT_HTTP_HEADERS['Content-Type']) ?? false)
  ) {
    headers = headers.append('Content-Type', DEFAULT_HTTP_HEADERS['Content-Type']);
  }

  return ldapTokenService.getToken().pipe(
    switchMap((token) => {
      if (token.username != null) {
        headers = headers.set(ACTOR_ID_HEADER, token.username);
      }
      return next(req.clone({ headers: headers.set('Authorization', `Bearer ${token.accessToken}`) }));
    })
  );
};
